import * as React from 'react';
import { Button } from '../components/buttons';
const classNames = require('classnames');
const { Collapse } = require('react-collapse');

import {
	IconChevronDown,
	HomeownersIconCheckOutline,
	HomeownersIconCrossOutline,
	HomeownersIconFlipDown,
	HomeownersIconFlipUp,
} from '../components/icons';

interface Props {
	icon: any;
	isOpened: boolean;
	onCollapseClick: () => void;
	primaryChildren: any;
	secondaryChildren: any;
	title: string;
}

const HomeownersHomeFlipCard: React.StatelessComponent<Props> = (props) => {
	return (
		<div className="flip-container flip-container-collapsible border-top shadow-none p-0">
			<Button
				className={classNames('btn-block d-lg-none section shadow-none flip-collapse-toggler', {'active': props.isOpened})}
				onClick={props.onCollapseClick}
			>
				<span className="media align-items-center">
					{props.icon}
					<span className="h4 mb-0 ml-3 media-body">{props.title}</span>
					<IconChevronDown className="flip-collapse-toggler-icon text-secondary ml-2" />
				</span>
			</Button>
			<Collapse
				isOpened={props.isOpened}
			>
				<div className="flipper flipper-vertical">
					<div className="front section shadow-none d-none d-lg-flex">
						<div className="row align-items-center font-weight-bold">
							<div className="col-lg-4 text-secondary media text-left align-items-center">
								<div className="flip-content-icon-wrapper">
									{props.icon}
								</div>
								<h3 className="mb-0 ml-4 media-body">{props.title}</h3>
							</div>
							<div className="col-lg text-center text-secondary large">
								Mosaic Life
								<br />
								Term Insurance
								<br />
								<i className="icon-maple-leaf-abstract" />
							</div>
							<div className="col-lg-auto large text-muted">
								vs.
							</div>
							<div className="col-lg text-center text-muted large">
								Creditor
								<br />
								Mortgage Insurance
							</div>
						</div>
						<HomeownersIconFlipUp className="flip-icon-marker" />
					</div>
					<div className="back section shadow-none">
						<div className="row">
							<div className="col-lg-4 align-self-center flip-content-icon-wrapper d-none d-lg-flex align-items-center">
								<div className="flip-content-icon-wrapper">
									{props.icon}
								</div>
								<h3 className="mb-0 ml-4 flex-fill text-reset">{props.title}</h3>
							</div>
							<div className="col-lg media mb-3 mb-lg-0">
								<HomeownersIconCheckOutline className="flip-icon-status" />
								<div className="media-body ml-3">
									{props.primaryChildren}
								</div>
							</div>
							<div className="col-lg media">
								<HomeownersIconCrossOutline className="flip-icon-status" />
								<div className="media-body ml-3">
									{props.secondaryChildren}
								</div>
							</div>
						</div>
						<HomeownersIconFlipDown className="flip-icon-marker d-none d-lg-block" />
					</div>
				</div>
			</Collapse>
		</div>
	);
};

export default HomeownersHomeFlipCard;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/landing/HomeownersHomeFlipCard.tsx